<template>
  <LibraryCard
    :url="shared ? sharedGoalUrl : goalUrl"
    :updated-time="goal.updated_at"
    :internal-link="true"
    :new-window="shared"
    :class="{'library-super-page': superpage}">
    <div class="library-card-body remove-resource-btn-container" :class="{'library-card-body--super-page': superpage}">
      <RemoveResourceButton
        v-if="!shared"
        :resource-id="contentUuid"
        :collection-id="collectionUuid"
        :type="resourceType" />
      <h4>{{ goal.title }}</h4>
      <AccessPointLabel
        v-if="goal.access_point_level"
        :level="goal.access_point_level"
        :limit-width="true"
        class="access-point-label--library"/>
      <span
        v-if="goal.subject"
        class="label label-success label--subheading ellipsis"
        :title="goal.subject">{{ goal.subject }}</span>
      <span class="label label-default label--subheading ellipsis" :title="goal.subject_domains.join(', ')">{{ goal.subject_domains.join(", ") }}</span>
      <span class="label label-warning label--subheading">{{ gradeLabelText }} {{ goal.grades.length > 1 && goal.grades[0] + "-" + goal.grades[goal.grades.length-1] || goal.grades.join(", ") }}</span>
      <div class="text-muted-dark"><WikiText :text="goal.grade_level_goal" :plaintext="true" /></div>
    </div>
    <div slot="footer-right">
      <span class="student-label fs-block" v-if="studentName">{{ studentName }}</span>
      <AnchorPageLabel v-if="superpage"/>
    </div>
  </LibraryCard>
</template>

<script>
import WikiText from '@/components/WikiText'
import LibraryCard from '@/components/library/LibraryCard'
import RemoveResourceButton from '@/components/library/RemoveResourceButton'
import AnchorPageLabel from '@/components/goals/AnchorPageLabel'
import AccessPointLabel from '@/components/goals/AccessPointLabel'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'LibraryGoalCard',
  components: {
    LibraryCard,
    WikiText,
    AnchorPageLabel,
    AccessPointLabel,
    RemoveResourceButton
  },
  props: {
    goal: {
      type: Object,
      required: true
    },
    studentName: {
      type: String,
      required: true
    },
    contentUuid: {
      type: String,
      required: true
    },
    collectionUuid: {
      type: String,
      required: true
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceType: CONTENT_TYPES.SAVED_GOAL
    }
  },
  computed: {
    goalUrl() {
      if (!this.superpage) {
        return { name: 'SavedGoalContentPage', params: { uuid: this.contentUuid } }
      } else {
        return { name: 'SavedAnchorPage', params: { uuid: this.contentUuid } }
      }
    },
    sharedGoalUrl() {
      if (!this.superpage) {
        return { name: 'SharedGoalContentPage', params: { uuid: this.contentUuid } }
      } else {
        return { name: 'SharedAnchorPage', params: { uuid: this.contentUuid } }
      }
    },
    gradeLabelText() {
      return (this.goal.grades.length > 1 && 'Grades') || 'Grade'
    },
    superpage() {
      return this.goal.super_page || false
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
@import '~@/globalstyles.less';
@import '~@/components/library/library_styles.less';
.library-card-body {
  overflow: hidden;
  height: 194px;
  padding: 20px;
  line-height: 20px;
  padding-bottom: 0px;
  margin-bottom: 12px;
  &:hover, &:focus {
    h4 {
      color: @link-hover-color;
    }
  }
  h4 {
    font-weight: bold;
    color: @link-color;
    margin-top: 0;
    margin-bottom: 2px;
  }
  .text-muted-dark {
    margin-top: 12px;
  }
  &.library-card-body--super-page {
    h4 {
      color: #1c5498;
    }
  }
}
</style>
<style lang="less">
.library-super-page {
  .library-card {
    background-color: #d7dde6 !important;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    &:hover {
      box-shadow: 0 1px 5px 0 rgb(0 0 0 / 50%);
      h4 {
        color: #142f46
      }
    }
  }
  .library-card__footer {
    background: #1c5498 !important;
    color: white !important;
    border-bottom-right-radius: none;
    border-bottom-left-radius: none;
  }
  .student-label {
    color: white !important;
  }
  .focus-styles {
    outline-offset: 1px;
  }
  &:focus-visible {
    .focus-styles;
  }
  @supports not selector(:focus-visible) {
    &:focus {
      .focus-styles;
    }
  }
}
.access-point-label--library {
  margin-right: 3px;
}
</style>
